import BaseEntity from './BaseEntity';
import Digest from './Digest';
export default class BranchCodeCoverage extends BaseEntity {
    constructor(codeCoverage) {
        super();
        this.commits = {};
        if (codeCoverage && codeCoverage.commits && Array.isArray(codeCoverage.commits)) {
            for (const key of Object.keys(codeCoverage.commits)) {
                const commit = codeCoverage.commits[key];
                const commitId = parseInt(commit.commitId, 10);
                this.commits[commitId] = {
                    digest: new Digest(this.parseProperty(commit, 'digest')),
                    ...(commit.digestDiff && {
                        digestDiff: new Digest(this.parseProperty(commit, 'digestDiff')),
                    }),
                };
            }
        }
    }
}
